'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowMinimiseOutline = function TiArrowMinimiseOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.7 10c0-1.3-0.6-2.6-1.5-3.5-0.9-1-2.2-1.5-3.5-1.5s-2.6 0.5-3.6 1.5l-1.4 1.4c-0.9-0.8-2.1-1.2-3.4-1.2-1.5 0-2.9 0.7-3.8 1.8-0.3-0.1-0.7-0.2-1.1-0.2h-10.1v10.1c0 0.5 0.1 0.9 0.2 1.3-1 0.9-1.6 2.2-1.6 3.6 0 1.3 0.4 2.4 1.1 3.3l-1.5 1.5c-1 1-1.5 2.2-1.5 3.6s0.5 2.6 1.5 3.5c0.9 0.9 2.2 1.5 3.5 1.5 0.9 0 2.2-0.3 3.4-1.5l1.5-1.5c0.9 0.8 2.1 1.3 3.4 1.3 1.6 0 3-0.7 3.9-1.8 0.4 0.1 0.8 0.1 1.2 0.1h9.9v-10.1c0-0.3 0-0.7-0.1-1.1 1.1-0.9 1.8-2.2 1.8-3.8 0-1.2-0.5-2.4-1.3-3.3l1.5-1.5c0.9-0.9 1.5-2.2 1.5-3.5z m-25 1.7h6.6c1 0 1.7 0.7 1.7 1.6s-0.7 1.7-1.7 1.7h-3.3v3.3c0 1-0.7 1.7-1.7 1.7-0.9 0-1.6-0.7-1.6-1.7v-6.6z m21.1-0.5l-5.4 5.5h2.6c0.9 0 1.7 0.7 1.7 1.6s-0.8 1.7-1.7 1.7h-8.3v-8.3c0-1 0.7-1.7 1.6-1.7s1.7 0.7 1.7 1.7v2.6l5.5-5.5c0.3-0.3 0.7-0.5 1.2-0.5s0.8 0.2 1.1 0.5c0.7 0.7 0.7 1.7 0 2.4z m-12.8 18.8c0 0.9-0.7 1.7-1.7 1.7s-1.6-0.8-1.6-1.7v-2.8l-5.6 5.6c-0.3 0.4-0.7 0.5-1.1 0.5s-0.9-0.1-1.2-0.5c-0.6-0.6-0.6-1.7 0-2.3l5.5-5.5h-2.4c-1 0-1.7-0.7-1.7-1.7s0.7-1.6 1.7-1.6h8.1v8.3z m0-10h-3.8c0.3-0.5 0.5-1.1 0.5-1.7v-1.6h1.7c0.6 0 1.1-0.2 1.6-0.4v3.7z m1.7 1.7h4.5c-0.7 0.1-1.2 0.5-1.2 1.5v1.8h-1.6c-0.6 0-1.2 0.2-1.7 0.5v-3.8z m0.1 6.6c0-0.9 0.7-1.6 1.6-1.6h3.3v-3.4c0-0.9 0.7-1.6 1.6-1.6s1.7 0.7 1.7 1.6v6.7h-6.6c-0.9 0-1.6-0.7-1.6-1.7z' })
        )
    );
};

exports.default = TiArrowMinimiseOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-minimise-outline.js
// module id = 3734
// module chunks = 0